import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const DynamicLandingPageRBAC = {
  pageID: 'fd854b09168053be0bb4dc3853d8c074',
  elementID: {
    ViewPage: '04cbe390781934f450e91300b3deb692',
    EditDLP: '1b0ccb120f0de5595c4bad848ab1c2b8',
    CopyDLP: '180cb701fb0de5595c5e657eb6e68ed9',
    DeleteDLP: '00c6e063040428e73001099bc0ebc1e7',
    CreateDLP: '2dbe81d12d04290b1f15ae029ef86918',
    ToggleStatusDLP: 'be73edfb0a1934f44871ef89eb493959',
  },
} as const

export const useRBACDynamicLandingPage = createUseRBAC(DynamicLandingPageRBAC.elementID)

export type UseRBACDynamicLandingPageType = ReturnType<typeof useRBACDynamicLandingPage>
